<template>
  <div class="no-results">
    <p :class="{'font-size-18': isDesktop, 'font-size-16': !isDesktop}" v-if="hasHeader">
      <slot name="header">The best is yet to come</slot>
    </p>
    <p>
      <img src="/static/img/magnifier/magnifier.webp"
           srcset="/static/img/magnifier/magnifier@2x.webp 1.5x,
           /static/img/magnifier/magnifier@2x.webp 2x,
             /static/img/magnifier/magnifier@3x.webp 3x"
      />
    </p>
    <p class="has-text-weight-normal no-results__para">
      <slot>The Business you were hoping to see here, may not be actively
        responding to reviews
        or may not have received 12 or more reviews in the past year.
      </slot>
    </p>
    <p class="no-results__sub-head">You can help by leaving a review.</p>
    <router-link :to="{ name: 'WriteReview' }" class="hp-btn-link" v-if="writeButton">
      WRITE A REVIEW
    </router-link>
  </div>
</template>
<script>
import {misc} from '@/mixins'

export default {
  name: 'BizNoResult',
  props: {
    writeButton: {
      type: Boolean,
      default: true
    }
  },
  mixins: [misc],
  computed: {
    hasHeader () {
      return !('header' in this.$slots) || !!this.$slots.header
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.no-results {
  text-align: center;
  font-weight: 600;
  padding-top: 19px;
  padding-bottom: 32px;
  max-width: 650px;
  margin: auto;

  @include tablet {
    font-size: 14px;
    max-width: 573px;
  }

  @include mobile {
    max-width: 266px;
  }

  img {
    padding-top: 38px;
    padding-bottom: 36px;
  }

  .no-results__sub-head {
    margin-top: 25px;
    margin-bottom: 39px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BizNoResult.vue